import { baseMenuItems } from "./menuBase";
import { adminMenuItems } from "./menuAdmin";
import { MENU_VISIBILITY_BY_COUNTRY } from "./menuByCountry";
import { COUNTRY_CODES } from "../../constants/countries";

const filterMenu = (items, hiddenKeys = []) => {
    return items
        .filter(item => !hiddenKeys.includes(item.key))
        .map(item => {
            if (item.children) {
                return {
                    ...item,
                    children: item.children.filter(
                        child => !hiddenKeys.includes(child.key)
                    )
                };
            }
            return item;
        });
};

export const getMenuItems = ({ isAdmin, country }) => {
    const countryRules = MENU_VISIBILITY_BY_COUNTRY[country?.code] ||  MENU_VISIBILITY_BY_COUNTRY[COUNTRY_CODES.ECUADOR];

    let items = [];

    if (isAdmin) {
        items = [
            baseMenuItems[0],
            adminMenuItems[0],
            baseMenuItems[1],
            baseMenuItems[2],
            baseMenuItems[3],
            adminMenuItems[1],
        ];
    } else {
        items = baseMenuItems;
    }

    if (countryRules.hide) {
        items = filterMenu(items, countryRules.hide);
    }

    return items;
};
